'use strict';

exports.__esModule = true;
exports.LocalStorage = exports.InMemory = exports.WebSocket = undefined;

var _rws = require('./rws');

Object.defineProperty(exports, 'WebSocket', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_rws).default;
  }
});

var _storage = require('./storage');

Object.defineProperty(exports, 'InMemory', {
  enumerable: true,
  get: function get() {
    return _storage.InMemory;
  }
});
Object.defineProperty(exports, 'LocalStorage', {
  enumerable: true,
  get: function get() {
    return _storage.LocalStorage;
  }
});

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _rws2 = _interopRequireDefault(_rws);

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _clock = require('@swarm/clock');

var _ronUuid = require('@swarm/ron-uuid');

var _rdt = require('@swarm/rdt');

var _pending = require('./pending');

var _pending2 = _interopRequireDefault(_pending);

var _connection = require('./connection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // for async/await work flow

var defaultMeta = {
  name: 'default',
  // FIXME clockMode: 'Calendar',
  clockLen: 5,
  forkMode: '// FIXME', // keep possible values sync with server
  peerIdBits: 30,
  horizont: 604800, // one week in seconds
  offset: 0
};

var SEEN = '0';
var META = '__meta__';

// A bare-bone swarm client. Consumes updates from the server,
// feeds resulting RON states back to the listeners.

var Client = function () {
  function Client(options) {
    _classCallCheck(this, Client);

    this.panic = this.panic.bind(this);
    this.onIdle = this.onIdle.bind(this);

    this.db = Object.assign({}, defaultMeta, options.db);
    this.storage = options.storage;
    this.lstn = {};
    this.queue = [];
    this.options = {
      hsTimeout: options.hsTimeout || 3e5 /* 5min */
      , fetchTimeout: options.fetchTimeout || 3e4 /* 30sec */
      , resendAfter: options.resendAfter || 0
    };
    this.init(options);
    this.seen = _ronUuid.ZERO;
    return this;
  }

  Client.prototype.init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee3(options) {
      var _this = this;

      var _ref2, meta, _seen, last;

      return _regeneratorRuntime2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.storage.multiGet([META, SEEN]);

            case 3:
              _ref2 = _context3.sent;
              meta = _ref2[META];
              _seen = _ref2[SEEN];
              last = _seen ? _ron.UUID.fromString(_seen) : _ronUuid.ZERO;


              this.db = Object.assign({}, this.db, JSON.parse(meta || '{}'));

              if (!(this.db.clockMode && this.db.id)) {
                _context3.next = 18;
                break;
              }

              _context3.t0 = this.db.clockMode;
              _context3.next = _context3.t0 === 'Logical' ? 12 : _context3.t0 === 'Calendar' ? 14 : 16;
              break;

            case 12:
              this.clock = new _clock.Logical(this.db.id, {
                length: this.db.clockLen,
                last: last
              });
              return _context3.abrupt('break', 17);

            case 14:
              this.clock = new _clock.Calendar(this.db.id, {
                offset: this.db.offset || 0,
                length: this.db.clockLen,
                last: last
              });
              return _context3.abrupt('break', 17);

            case 16:
              throw new Error('TODO: Clock mode \'' + this.db.clockMode + '\' is not supported yet');

            case 17:
              this.seen = last;

            case 18:
              if (!(typeof options.upstream === 'string')) {
                _context3.next = 22;
                break;
              }

              this.upstream = new _rws2.default(options.upstream, undefined, {
                reconnectOnError: true
              });
              _context3.next = 32;
              break;

            case 22:
              if (!options.upstream) {
                _context3.next = 26;
                break;
              }

              this.upstream = options.upstream;
              _context3.next = 32;
              break;

            case 26:
              if (!(!options.upstream && this.db.clockMode)) {
                _context3.next = 30;
                break;
              }

              this.upstream = new _connection.DevNull();
              _context3.next = 32;
              break;

            case 30:
              if (!(!options.upstream && !this.db.clockMode)) {
                _context3.next = 32;
                break;
              }

              throw new Error('neither connection options nor clock options found');

            case 32:
              _context3.next = 34;
              return _pending2.default.read(this.storage);

            case 34:
              this.pending = _context3.sent;


              // check if we start with an already existing replica
              if (meta && this.clock) {
                this.upstream.onopen = function () {
                  return _this.handshake().catch(function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee(e) {
                      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this.close();

                            case 2:
                              _this.panic(e);

                            case 3:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                };
                this.release(null);
              } else {
                this.upstream.onopen = function () {
                  return _this.handshake().then(function () {
                    return _this.release(null);
                  }).catch(function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee2(e) {
                      return _regeneratorRuntime2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return _this.close();

                            case 2:
                              _this.release(e);

                            case 3:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this);
                    }));

                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }());
                };
              }
              _context3.next = 41;
              break;

            case 38:
              _context3.prev = 38;
              _context3.t1 = _context3['catch'](0);

              this.release(_context3.t1);

            case 41:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 38]]);
    }));

    function init(_x) {
      return _ref.apply(this, arguments);
    }

    return init;
  }();

  Client.prototype.handshake = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee4() {
      var _this2 = this;

      var hs, hello, head, auth, resp, dbOpts, seen, _iterator, _isArray, _i, _ref6, _op, val, _key, op, resendAfter, _iterator2, _isArray2, _i2, _ref7, p, query;

      return _regeneratorRuntime2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.upstream instanceof _connection.DevNull)) {
                _context4.next = 5;
                break;
              }

              _context4.next = 3;
              return this.storage.set(META, JSON.stringify(this.db));

            case 3:
              this.upstream.onmessage = function (me) {
                _this2.onMessage(me.data).catch(_this2.panic);
              };
              return _context4.abrupt('return');

            case 5:
              hs = new Promise(function (resolve, reject) {
                setTimeout(reject, _this2.options.hsTimeout);
                _this2.upstream.onmessage = function (me) {
                  return resolve(me.data);
                };
              });
              hello = new _ron.Frame();
              head = new _ron2.default(new _ron.UUID('db', '0', '$'), new _ron.UUID(this.db.name, '0', '$'), new _ron.UUID(this.seen.value, this.db.id || '0', '+'), _ronUuid.ZERO, undefined, _ron.QUERY_SEP);

              hello.push(head);
              hello.pushWithTerm(head, _ron.FRAME_SEP);

              auth = this.db.auth;

              if (auth) {
                hello.push(new _ron2.default(head.uuid(0), head.uuid(1), head.uuid(2), head.uuid(3), (0, _ron.js2ron)([auth]), ','));
              }
              this.upstream.send(hello.toString());

              _context4.next = 15;
              return hs;

            case 15:
              resp = _context4.sent;
              dbOpts = Object.assign({
                clockMode: 'Calendar'
              }, this.db);
              seen = _ronUuid.ZERO;
              _iterator = new _ron.Frame(resp), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();

            case 19:
              if (!_isArray) {
                _context4.next = 25;
                break;
              }

              if (!(_i >= _iterator.length)) {
                _context4.next = 22;
                break;
              }

              return _context4.abrupt('break', 38);

            case 22:
              _ref6 = _iterator[_i++];
              _context4.next = 29;
              break;

            case 25:
              _i = _iterator.next();

              if (!_i.done) {
                _context4.next = 28;
                break;
              }

              return _context4.abrupt('break', 38);

            case 28:
              _ref6 = _i.value;

            case 29:
              _op = _ref6;

              if (!_op.uuid(3).isError()) {
                _context4.next = 33;
                break;
              }

              this.close();
              throw new Error('Handshake error: ' + _op.uuid(3).toString());

            case 33:
              if (seen.eq(_ronUuid.ZERO)) {
                seen = _op.uuid(2);
              }
              val = _op.value(0);

              if (val) {
                _key = _op.uuid(3).toString();

                _key = _key[0].toLowerCase() + _key.slice(1);
                dbOpts[_key] = val instanceof _ron.UUID ? val.value : val;
              }

            case 36:
              _context4.next = 19;
              break;

            case 38:
              op = _ron2.default.fromString(resp);

              if (!op) {
                _context4.next = 43;
                break;
              }

              dbOpts.id = op.uuid(1).origin;
              _context4.next = 44;
              break;

            case 43:
              throw new Error('Expected replica id not found in a handshake response: \n\t\'' + (op || '').toString() + '\'');

            case 44:
              if (!this.clock) {
                _context4.next = 49;
                break;
              }

              if (!(this.db.clockMode !== dbOpts.clockMode)) {
                _context4.next = 47;
                break;
              }

              throw new Error('Different clock mode: \'' + (this.db.clockMode || 'undefined') + '\' !== \'' + (dbOpts.clockMode || 'undefined') + '\'');

            case 47:
              _context4.next = 61;
              break;

            case 49:
              if (!dbOpts.id) {
                _context4.next = 60;
                break;
              }

              _context4.t0 = dbOpts.clockMode;
              _context4.next = _context4.t0 === 'Logical' ? 53 : _context4.t0 === 'Calendar' ? 55 : 57;
              break;

            case 53:
              this.clock = new _clock.Logical(dbOpts.id, { length: dbOpts.clockLen });
              return _context4.abrupt('break', 58);

            case 55:
              this.clock = new _clock.Calendar(dbOpts.id, { length: dbOpts.clockLen });
              return _context4.abrupt('break', 58);

            case 57:
              throw new Error('Clock mode \'' + (dbOpts.clockMode || 'undefined') + '\' is not supported yet');

            case 58:
              _context4.next = 61;
              break;

            case 60:
              throw new Error('Clock mode \'' + (dbOpts.clockMode || 'undefined') + '\' is not supported yet');

            case 61:

              dbOpts.offset = this.clock.adjust(dbOpts['0'] || seen);
              delete dbOpts['0'];

              this.db = Object.assign({}, this.db, dbOpts);
              _context4.next = 66;
              return this.storage.set(META, JSON.stringify(this.db));

            case 66:
              this.upstream.onmessage = function (me) {
                return _this2.onMessage(me.data).catch(_this2.panic);
              };
              this.upstream.onopen = function () {
                return _this2.handshake().catch(_this2.panic);
              };

              resendAfter = this.options.resendAfter;

              if (!resendAfter) {
                _context4.next = 74;
                break;
              }

              this.pending.onIdle(this.onIdle);
              this.pending.setIdlePeriod(resendAfter);
              _context4.next = 89;
              break;

            case 74:
              _iterator2 = this.pending, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();

            case 75:
              if (!_isArray2) {
                _context4.next = 81;
                break;
              }

              if (!(_i2 >= _iterator2.length)) {
                _context4.next = 78;
                break;
              }

              return _context4.abrupt('break', 89);

            case 78:
              _ref7 = _iterator2[_i2++];
              _context4.next = 85;
              break;

            case 81:
              _i2 = _iterator2.next();

              if (!_i2.done) {
                _context4.next = 84;
                break;
              }

              return _context4.abrupt('break', 89);

            case 84:
              _ref7 = _i2.value;

            case 85:
              p = _ref7;
              this.upstream.send(p);

            case 87:
              _context4.next = 75;
              break;

            case 89:

              // Re-subscribe
              query = Object.keys(this.lstn);

              if (!query.length) {
                _context4.next = 93;
                break;
              }

              _context4.next = 93;
              return this.on('#' + query.join('#'));

            case 93:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function handshake() {
      return _ref5.apply(this, arguments);
    }

    return handshake;
  }();

  // Ensure returns Promise which will be resolved after connection
  // installed or rejected if an error occurred.


  Client.prototype.ensure = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee5() {
      var queue;
      return _regeneratorRuntime2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queue = this.queue;

              if (!(queue === undefined)) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt('return', Promise.resolve());

            case 5:
              return _context5.abrupt('return', new Promise(function (release, reject) {
                queue.push([release, reject]);
              }));

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function ensure() {
      return _ref8.apply(this, arguments);
    }

    return ensure;
  }();

  Client.prototype.release = function release(err) {
    if (!this.queue) return;
    for (var _iterator3 = this.queue, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref9;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref9 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref9 = _i3.value;
      }

      var cbk = _ref9;

      if (err) {
        cbk[1](err);
      } else {
        cbk[0]();
      }
    }
    delete this.queue;
  };

  Client.prototype.close = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee6() {
      return _regeneratorRuntime2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (this.upstream) this.upstream.close();
              this.pending.onIdle(function () {});
              this.pending.setIdlePeriod(0);
              _context6.next = 5;
              return this.pending.flush();

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function close() {
      return _ref10.apply(this, arguments);
    }

    return close;
  }();

  Client.prototype.open = function open() {
    if (this.upstream) {
      this.upstream.open();
    }
  };

  Client.prototype.onMessage = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee7(message) {
      var clock, _iterator4, _isArray4, _i4, _ref12, op, _seen2, _iterator5, _isArray5, _i5, _ref13, _f;

      return _regeneratorRuntime2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              clock = this.clock;

              if (clock) {
                _context7.next = 3;
                break;
              }

              throw new Error('Have no clock');

            case 3:
              _iterator4 = new _ron.Frame(message), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();

            case 4:
              if (!_isArray4) {
                _context7.next = 10;
                break;
              }

              if (!(_i4 >= _iterator4.length)) {
                _context7.next = 7;
                break;
              }

              return _context7.abrupt('break', 28);

            case 7:
              _ref12 = _iterator4[_i4++];
              _context7.next = 14;
              break;

            case 10:
              _i4 = _iterator4.next();

              if (!_i4.done) {
                _context7.next = 13;
                break;
              }

              return _context7.abrupt('break', 28);

            case 13:
              _ref12 = _i4.value;

            case 14:
              op = _ref12;

              if (!(op.uuid(0).toString() === 'db')) {
                _context7.next = 18;
                break;
              }

              this.close();
              // TODO destroy replica ?
              throw new Error(op.toString());

            case 18:
              if (op.event.eq(_ronUuid.NEVER)) {
                _context7.next = 25;
                break;
              }

              _context7.next = 21;
              return this.see(op.event);

            case 21:
              if (!(op.event.origin === clock.origin())) {
                _context7.next = 25;
                break;
              }

              _context7.next = 24;
              return this.pending.release(op.event);

            case 24:
              _seen2 = _context7.sent;

            case 25:
              return _context7.abrupt('break', 28);

            case 26:
              _context7.next = 4;
              break;

            case 28:
              _iterator5 = _ron.Batch.splitByID(message), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();

            case 29:
              if (!_isArray5) {
                _context7.next = 35;
                break;
              }

              if (!(_i5 >= _iterator5.length)) {
                _context7.next = 32;
                break;
              }

              return _context7.abrupt('break', 44);

            case 32:
              _ref13 = _iterator5[_i5++];
              _context7.next = 39;
              break;

            case 35:
              _i5 = _iterator5.next();

              if (!_i5.done) {
                _context7.next = 38;
                break;
              }

              return _context7.abrupt('break', 44);

            case 38:
              _ref13 = _i5.value;

            case 39:
              _f = _ref13;
              _context7.next = 42;
              return this.merge(_f.toString(), { local: false });

            case 42:
              _context7.next = 29;
              break;

            case 44:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function onMessage(_x4) {
      return _ref11.apply(this, arguments);
    }

    return onMessage;
  }();

  // On installs subscriptions.


  Client.prototype.on = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee8(query, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var fwd, upstrm, wrapped, onceSent, keys, data, _iterator6, _isArray6, _i6, _ref15, _key2, _id, base, stored, _iterator7, _isArray7, _i7, _ref16, op, found, exists, _iterator8, _isArray8, _i8, _ref17, l;

      return _regeneratorRuntime2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.ensure();

            case 2:
              fwd = new _ron.Frame();
              upstrm = new _ron.Frame();
              wrapped = Object.assign({ f: callback }, options);
              onceSent = 0;
              keys = new _ron.Frame(query).unzip().map(function (op) {
                if (op.uuid(1).eq(_ronUuid.ZERO)) throw new Error('ID is not specified: "' + op.toString() + '"');
                return op.uuid(1).toString();
              });
              _context8.next = 9;
              return this.storage.multiGet(keys.concat('0'));

            case 9:
              data = _context8.sent;
              _iterator6 = keys, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();

            case 11:
              if (!_isArray6) {
                _context8.next = 17;
                break;
              }

              if (!(_i6 >= _iterator6.length)) {
                _context8.next = 14;
                break;
              }

              return _context8.abrupt('break', 69);

            case 14:
              _ref15 = _iterator6[_i6++];
              _context8.next = 21;
              break;

            case 17:
              _i6 = _iterator6.next();

              if (!_i6.done) {
                _context8.next = 20;
                break;
              }

              return _context8.abrupt('break', 69);

            case 20:
              _ref15 = _i6.value;

            case 21:
              _key2 = _ref15;
              _id = _ron.UUID.fromString(_key2);
              base = _ronUuid.ZERO;
              stored = data[_key2];

              // try to avoid network request

              if (!(callback && wrapped.once && (stored !== null || !wrapped.ensure))) {
                _context8.next = 30;
                break;
              }

              callback('#' + _key2, stored);
              onceSent++;
              _context8.next = 67;
              break;

            case 30:
              if (!stored) {
                _context8.next = 47;
                break;
              }

              _iterator7 = new _ron.Frame(stored), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();

            case 32:
              if (!_isArray7) {
                _context8.next = 38;
                break;
              }

              if (!(_i7 >= _iterator7.length)) {
                _context8.next = 35;
                break;
              }

              return _context8.abrupt('break', 47);

            case 35:
              _ref16 = _iterator7[_i7++];
              _context8.next = 42;
              break;

            case 38:
              _i7 = _iterator7.next();

              if (!_i7.done) {
                _context8.next = 41;
                break;
              }

              return _context8.abrupt('break', 47);

            case 41:
              _ref16 = _i7.value;

            case 42:
              op = _ref16;

              base = op.event.lt(this.seen) ? op.event : this.seen;
              // base = op.event;
              return _context8.abrupt('break', 47);

            case 45:
              _context8.next = 32;
              break;

            case 47:
              found = false;
              exists = !!callback && !!this.lstn[_key2] && this.lstn[_key2].length;

              if (!wrapped.f) {
                _context8.next = 66;
                break;
              }

              _iterator8 = this.lstn[_key2] || [], _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();

            case 51:
              if (!_isArray8) {
                _context8.next = 57;
                break;
              }

              if (!(_i8 >= _iterator8.length)) {
                _context8.next = 54;
                break;
              }

              return _context8.abrupt('break', 65);

            case 54:
              _ref17 = _iterator8[_i8++];
              _context8.next = 61;
              break;

            case 57:
              _i8 = _iterator8.next();

              if (!_i8.done) {
                _context8.next = 60;
                break;
              }

              return _context8.abrupt('break', 65);

            case 60:
              _ref17 = _i8.value;

            case 61:
              l = _ref17;

              found = found || l.f === wrapped.f;

            case 63:
              _context8.next = 51;
              break;

            case 65:

              if (!found) {
                // $FlowFixMe
                this.lstn[_key2] = (this.lstn[_key2] || []).concat([wrapped]);
              }

            case 66:

              if (!found) {
                if (!exists && !_id.isLocal()) {
                  upstrm.push(new _ron2.default(_ronUuid.ZERO, _id, base, _ronUuid.ZERO, '', _ron.QUERY_SEP + _ron.FRAME_SEP)); // FIXME check fork mode
                }
                fwd.push(new _ron2.default(_ronUuid.ZERO, _id, base, _ronUuid.ZERO, '', _ron.QUERY_SEP + _ron.FRAME_SEP)); // FIXME check fork mode
              }

            case 67:
              _context8.next = 11;
              break;

            case 69:

              if (this.upstream && this.clock && upstrm.toString()) {
                this.upstream.send(upstrm.toString());
              }

              if (!(callback && fwd.toString())) {
                _context8.next = 73;
                break;
              }

              _context8.next = 73;
              return this.notify(fwd.toString(), wrapped);

            case 73:
              return _context8.abrupt('return', !!fwd.toString() || !!onceSent);

            case 74:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function on(_x6, _x7) {
      return _ref14.apply(this, arguments);
    }

    return on;
  }();

  // Off removes subscriptions.


  Client.prototype.off = function off(q, callback) {
    // unless query passed fetch all the keys to unsubscribe from them
    var query = q || Object.keys(this.lstn).map(function (i) {
      return '#' + i;
    }).join('');
    var c = 0;
    var fwd = new _ron.Frame();
    fwd.push(new _ron2.default(_ronUuid.ZERO, _ronUuid.ZERO, _ronUuid.NEVER, _ronUuid.ZERO, undefined, _ron.QUERY_SEP));

    for (var _iterator9 = new _ron.Frame(query), _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
      var _ref18;

      if (_isArray9) {
        if (_i9 >= _iterator9.length) break;
        _ref18 = _iterator9[_i9++];
      } else {
        _i9 = _iterator9.next();
        if (_i9.done) break;
        _ref18 = _i9.value;
      }

      var op = _ref18;

      var _key3 = op.uuid(1).toString();
      if (!this.lstn[_key3]) continue;
      if (callback) {
        this.lstn[_key3] = this.lstn[_key3].filter(function (cbk) {
          return cbk.f !== callback;
        });
        if (!this.lstn[_key3].length) {
          if (!op.uuid(1).isLocal()) {
            fwd.push(new _ron2.default(op.type, op.object, _ronUuid.NEVER, _ronUuid.ZERO, undefined, ','));
            c++;
          }
          delete this.lstn[_key3];
        }
      } else {
        if (!op.uuid(1).isLocal()) {
          fwd.push(new _ron2.default(op.type, op.object, _ronUuid.NEVER, _ronUuid.ZERO, undefined, ','));
          c++;
        }
        delete this.lstn[_key3];
      }
    }
    if (!!c) {
      this.upstream.send(fwd.toString());
      return fwd.toString();
    }
    return;
  };

  // Push sends updates to remote and local storages.
  // Waits for connection installed. Thus, the client works in
  // read-only mode until installed connection.


  Client.prototype.push = function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee9(rawFrame) {
      var _this3 = this;

      var stamps, frame, filtered;
      return _regeneratorRuntime2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.ensure();

            case 2:
              stamps = {};
              frame = (0, _ron.mapUUIDs)(rawFrame, function (uuid, position) {
                if (position === 0) return uuid.eq(_ronUuid.ZERO) ? _rdt.lww.type : uuid;
                if (position > 2 || !uuid.eq(_ronUuid.ZERO)) return uuid;
                var exists = stamps[uuid.toString()];
                // $FlowFixMe
                return exists ? exists : stamps[uuid.toString()] = _this3.clock.time();
              });
              filtered = new _ron.Frame(frame).filter(function (op) {
                return !op.uuid(1).isLocal();
              }).toString();

              if (!filtered) {
                _context9.next = 9;
                break;
              }

              _context9.next = 8;
              return this.pending.push(filtered);

            case 8:
              this.upstream.send(filtered);

            case 9:
              _context9.next = 11;
              return this.merge(frame, { local: true });

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function push(_x8) {
      return _ref19.apply(this, arguments);
    }

    return push;
  }();

  // Notify calls back with an existing states


  Client.prototype.notify = function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee10(frame, callback) {
      var keys, _iterator10, _isArray10, _i10, _ref21, op, ks, store, _iterator11, _isArray11, _i11, _ref22, _key4, value, isLocal;

      return _regeneratorRuntime2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (callback.f) {
                _context10.next = 2;
                break;
              }

              return _context10.abrupt('return');

            case 2:
              keys = {};
              _iterator10 = new _ron.Frame(frame), _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();

            case 4:
              if (!_isArray10) {
                _context10.next = 10;
                break;
              }

              if (!(_i10 >= _iterator10.length)) {
                _context10.next = 7;
                break;
              }

              return _context10.abrupt('break', 18);

            case 7:
              _ref21 = _iterator10[_i10++];
              _context10.next = 14;
              break;

            case 10:
              _i10 = _iterator10.next();

              if (!_i10.done) {
                _context10.next = 13;
                break;
              }

              return _context10.abrupt('break', 18);

            case 13:
              _ref21 = _i10.value;

            case 14:
              op = _ref21;
              keys[op.uuid(1).toString()] = true;

            case 16:
              _context10.next = 4;
              break;

            case 18:
              ks = Object.keys(keys);
              _context10.next = 21;
              return this.storage.multiGet(ks);

            case 21:
              store = _context10.sent;
              _iterator11 = ks, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();

            case 23:
              if (!_isArray11) {
                _context10.next = 29;
                break;
              }

              if (!(_i11 >= _iterator11.length)) {
                _context10.next = 26;
                break;
              }

              return _context10.abrupt('break', 39);

            case 26:
              _ref22 = _iterator11[_i11++];
              _context10.next = 33;
              break;

            case 29:
              _i11 = _iterator11.next();

              if (!_i11.done) {
                _context10.next = 32;
                break;
              }

              return _context10.abrupt('break', 39);

            case 32:
              _ref22 = _i11.value;

            case 33:
              _key4 = _ref22;
              value = store[_key4];
              isLocal = _key4.slice(_key4.length - _ronUuid.LOCAL.length) === _ronUuid.LOCAL;

              if (!callback.ensure || value !== null || isLocal) {
                if (callback.once) this.off('#' + _key4, callback.f);
                // $FlowFixMe
                callback.f('#' + _key4, isLocal ? value || '' : value);
              }

            case 37:
              _context10.next = 23;
              break;

            case 39:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function notify(_x9, _x10) {
      return _ref20.apply(this, arguments);
    }

    return notify;
  }();

  // Merge updates local state and notifies listeners.
  // Accepts single frame.
  //    notifies listeners with empty payload
  //    if there is no saved state


  Client.prototype.merge = function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee11(frame) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { local: true };

      var fr, _iterator12, _isArray12, _i12, _ref24, op, _key5, notify, updated, _iterator13, _isArray13, _i13, _ref25, l;

      return _regeneratorRuntime2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              fr = new _ron.Frame(frame);

              // Read only first operation of the frame
              // but with guarantee.

              _iterator12 = fr, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();

            case 2:
              if (!_isArray12) {
                _context11.next = 8;
                break;
              }

              if (!(_i12 >= _iterator12.length)) {
                _context11.next = 5;
                break;
              }

              return _context11.abrupt('break', 39);

            case 5:
              _ref24 = _iterator12[_i12++];
              _context11.next = 12;
              break;

            case 8:
              _i12 = _iterator12.next();

              if (!_i12.done) {
                _context11.next = 11;
                break;
              }

              return _context11.abrupt('break', 39);

            case 11:
              _ref24 = _i12.value;

            case 12:
              op = _ref24;
              _key5 = op.uuid(1).toString();

              if (!(_key5 === '0')) {
                _context11.next = 16;
                break;
              }

              return _context11.abrupt('return');

            case 16:
              // ack

              notify = false;
              _context11.next = 19;
              return this.storage.merge(_key5, function (prev) {
                if (fr.isPayload()) {
                  if (typeof prev === 'string') {
                    var update = (0, _rdt.reduce)(_ron.Batch.fromStringArray(prev, frame)).toString();
                    notify = prev !== update;
                    return update;
                  }
                  notify = true;
                  return frame;
                }

                // An empty state from the server whereas a local state is full
                if (prev !== null) {
                  return prev;
                }

                // Empty state from a server, hence, an object does not exist in the system.
                notify = true;
                return '';
              });

            case 19:
              updated = _context11.sent;

              if (!notify) {
                _context11.next = 36;
                break;
              }

              _iterator13 = (this.lstn[_key5] || []).slice(), _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();

            case 22:
              if (!_isArray13) {
                _context11.next = 28;
                break;
              }

              if (!(_i13 >= _iterator13.length)) {
                _context11.next = 25;
                break;
              }

              return _context11.abrupt('break', 36);

            case 25:
              _ref25 = _iterator13[_i13++];
              _context11.next = 32;
              break;

            case 28:
              _i13 = _iterator13.next();

              if (!_i13.done) {
                _context11.next = 31;
                break;
              }

              return _context11.abrupt('break', 36);

            case 31:
              _ref25 = _i13.value;

            case 32:
              l = _ref25;

              if (!l.ensure || updated !== null) {
                if (l.once) this.off('#' + _key5, l.f);
                l.f('#' + _key5, updated);
              }

            case 34:
              _context11.next = 22;
              break;

            case 36:
              return _context11.abrupt('break', 39);

            case 37:
              _context11.next = 2;
              break;

            case 39:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function merge(_x12) {
      return _ref23.apply(this, arguments);
    }

    return merge;
  }();

  Client.prototype.see = function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee12(event) {
      var clock;
      return _regeneratorRuntime2.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              clock = this.clock;

              if (!(clock && clock.see(event))) {
                _context12.next = 5;
                break;
              }

              this.seen = event;
              _context12.next = 5;
              return this.storage.set(SEEN, event.toString());

            case 5:
              return _context12.abrupt('return', event);

            case 6:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function see(_x13) {
      return _ref26.apply(this, arguments);
    }

    return see;
  }();

  Client.prototype.panic = function panic(err) {
    console.error('panic: %s', err);
  };

  Client.prototype.onIdle = function onIdle() {
    // Resend all the frames
    for (var _iterator14 = this.pending, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
      var _ref27;

      if (_isArray14) {
        if (_i14 >= _iterator14.length) break;
        _ref27 = _iterator14[_i14++];
      } else {
        _i14 = _iterator14.next();
        if (_i14.done) break;
        _ref27 = _i14.value;
      }

      var p = _ref27;
      this.upstream.send(p);
    }
  };

  return Client;
}();

exports.default = Client;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/client/lib/index.js
// module id = 33
// module chunks = 0